interface IValua {
  name: string;
  from: number;
  to: number;
}

type TMapFunction = (values: string[]) => (holeValue: IValua) => number;

export const getHolesTotal: TMapFunction = values => holeValue =>
  values
    .slice(holeValue.from, holeValue.to + 1)
    .reduce((sum, hValue) => sum + (Number(hValue) || 0), 0);
